var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('sidebar-fixed-toggle-button'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":_vm.$t('sidebar.shortTitle'),"title":_vm.customerName,"logo":_vm.logo},scopedSlots:_vm._u([{key:"links",fn:function(props){return [_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.dashboard'),
            icon: 'home',
            path: '/dashboard'
          }}}),(_vm.canView('view-school'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.school'),
            icon: 'building',
            path: '/school'
          }}}):_vm._e(),(_vm.canView('view-number'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.phonenumbers'),
            icon: 'phone',
            path: '/numbers'
          }}}):_vm._e(),(_vm.canView('view-device'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.sipdevices'),
            icon: 'phone-office',
            path: '/devices'
          }}}):_vm._e(),(_vm.canView('view-invoice'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.billing'),
            icon: 'file-invoice-dollar',
            path: '/billing'
          }}}):_vm._e(),(_vm.canView('view-voicemailbox'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.voicemailbox'),
            icon: 'voicemail',
            path: '/voicemailbox'
          }}}):_vm._e(),(_vm.canView('view-cdr'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.callrecords'),
            icon: 'table',
            path: '/callrecords'
          }}}):_vm._e(),(_vm.canView('view-ivr'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ivrs'),
            icon: 'headset',
            path: '/ivrs'
          }}}):_vm._e(),(_vm.canView('view-musiconhold'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.musiconhold'),
            icon: 'pause',
            path: '/musiconhold'
          }}}):_vm._e(),(_vm.canView('view-internal'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.internal'),
            icon: 'building',
            path: '/internal'
          }}}):_vm._e(),(_vm.canView('view-queue'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.queues'),
            icon: 'user-clock',
            path: '/queues'
          }}}):_vm._e(),(_vm.canView('view-ringgroup'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.ringgroups'),
            icon: 'users',
            path: '/ringgroups'
          }}}):_vm._e(),(_vm.canView('view-timecondition'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.timeconditions'),
            icon: 'clock',
            path: '/timeconditions'
          }}}):_vm._e(),(_vm.canView('view-contacts'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.contacts'),
            icon: 'user',
            path: '/contact'
          }}}):_vm._e(),(_vm.canView('view-school'))?_c('sidebar-item',{attrs:{"link":{
            name: _vm.$t('sidebar.bulletins'),
            icon: 'list-music',
            path: '/bulletins'
          }}}):_vm._e()]}}])}),_c('div',{staticClass:"main-panel",attrs:{"data":_vm.sidebarBackground}},[_c('dashboard-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }